import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'dojo-card-link',
  standalone: true,
  templateUrl: './card-link.component.html',
  styleUrls: ['./card-link.component.scss'],
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class CardComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() buttonText = '';
  @Input() imageSrc = '';
}
